import Vue from 'vue'
import VueRouter from 'vue-router'

// import StayTuned from '@/pages/StayTuned'
import Landing from '@/pages/Landing'
import Info from '@/pages/Info'
import Teams from '@/pages/Teams'
import About from '@/pages/About'
import Schedule from '@/pages/Schedule'
import Tickets from '@/pages/Tickets'
import Photos from '@/pages/Photos'
import Sponsors from '@/pages/Sponsors'
import SignUp from '@/pages/SignUp'
import NotFound from '@/pages/NotFound'

Vue.use(VueRouter)

var vueRouter = new VueRouter({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'staytuned',
    //   id: -1,
    //   title: 'Stay Tuned',
    //   component: StayTuned
    // },
    {
      path: '/',
      name: 'landing',
      id: 0,
      title: 'Landing',
      component: Landing
    },
    {
      path: '/info',
      name: 'info',
      id: 1,
      title: 'Info',
      component: Info
    },
    {
      path: '/teams',
      name: 'teams',
      id: 10,
      title: 'Teams',
      component: Teams
    },
    {
      path: '/about',
      name: 'about',
      id: 11,
      title: 'About',
      component: About
    },
    {
      path: '/schedule',
      name: 'schedule',
      id: 2,
      title: 'Schedule',
      component: Schedule
    },
    {
      path: '/tickets',
      name: 'tickets',
      id: 3,
      title: 'Tickets',
      component: Tickets
    },
    {
      path: '/photos',
      name: 'photos',
      id: 4,
      title: 'Photos',
      component: Photos
    },
    {
      path: '/sponsors',
      name: 'sponsors',
      id: 5,
      title: 'Sponsors',
      component: Sponsors
    },
    {
      path: '/signup',
      name: 'signup',
      id: 6,
      title: 'Signup',
      component: SignUp
    },
    {
      path: '*',
      name: 'notfound',
      id: 404,
      title: 'Not Found',
      component: NotFound
    }
  ]
})

export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js